/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-partnership-details{padding:20px;display:block}app-partnership-details .formgroup{margin:10px 0;box-sizing:border-box}app-partnership-details .action{cursor:pointer;text-decoration:none}app-partnership-details .action:hover{background:#c4c5c4}"];
export { styles as styles };
